import type { Entry } from "../types";

export const appMessages = {
  appName: { ko: "컴플라이언스 세이지", en: "Compliance Sage" },
  tagline: {
    ko: "보험 광고 컴플라이언스 사전 검토 플랫폼",
    en: "Insurance advertising compliance pre-review platform",
  },
  login: { ko: "VaultSage로 로그인", en: "Login with VaultSage" },
  language: { ko: "언어", en: "Language" },
  loginEyebrow: { ko: "안전한 컴플라이언스 워크스페이스", en: "Secure compliance workspace" },
  loginHeroTitle: {
    ko: "더 신뢰할 수 있는 광고 검토를 시작하세요.",
    en: "Start every advertising review with confidence.",
  },
  loginHeroDescription: {
    ko: "팀의 정책과 규정을 한곳에서 관리하고, 검토 결과를 명확하게 기록하세요.",
    en: "Manage your team’s policies and regulations in one place, with a clear record of every decision.",
  },
  loginTitle: { ko: "로그인", en: "Sign in" },
  loginDescription: {
    ko: "VaultSage 계정으로 안전하게 계속하세요.",
    en: "Continue securely with your VaultSage account.",
  },
  loginLoading: { ko: "VaultSage로 이동 중...", en: "Connecting to VaultSage..." },
  loginStartError: {
    ko: "로그인을 시작할 수 없습니다. 잠시 후 다시 시도해 주세요.",
    en: "We couldn’t start sign-in. Please try again shortly.",
  },
  logout: { ko: "로그아웃", en: "Logout" },
  loginNotice: {
    ko: "초대된 계정만 로그인할 수 있습니다. 인증은 VaultSage에서 안전하게 처리됩니다.",
    en: "Only invited accounts can sign in. Authentication is handled securely by VaultSage.",
  },
  loginSecurityNote: {
    ko: "초대된 팀원만 접근할 수 있는 안전한 검토 환경",
    en: "A protected review environment for invited team members.",
  },
  loginSupport: {
    ko: "접근 권한이 필요하신가요? 조직 관리자에게 문의해 주세요.",
    en: "Need access? Contact your organization administrator.",
  },
  sidebarSectionStandards: { ko: "기준 수립", en: "Define standards" },
  sidebarSectionStandardsReadOnly: { ko: "참고 기준", en: "Reference library" },
  standardsReadOnlyNotice: {
    ko: "읽기 전용입니다. 현재 시행 중인 기준만 표시됩니다.",
    en: "Read-only. Only standards currently in force are shown.",
  },
  sidebarSectionOperations: { ko: "운영과 감사", en: "Operate and audit" },
  navDashboard: { ko: "대시보드", en: "Dashboard" },
  navHome: { ko: "홈", en: "Home" },
  navMyReviews: { ko: "내 검토 요청", en: "My reviews" },
  dashboardRequesterTitle: { ko: "광고 검토를 시작하세요", en: "Start an advertising review" },
  dashboardRequesterIntro: {
    ko: "자료를 제출하고 검토 상태를 확인하세요. 조치가 필요하면 각 검토에서 안내합니다.",
    en: "Submit material and track its review. Each review tells you when action is needed.",
  },
  dashboardOfficerTitle: { ko: "검토할 업무를 확인하세요", en: "See what needs a decision" },
  dashboardOfficerIntro: {
    ko: "결정 대기 중인 검토의 자료와 근거를 확인하고 최종 결정을 기록하세요.",
    en: "Inspect reviews that need a decision, then record the final outcome.",
  },
  dashboardOpenQueue: { ko: "결정 대기 검토 열기", en: "Open reviews needing decision" },
  dashboardRecentReviews: { ko: "검토 현황", en: "Review activity" },
  dashboardMyRecentReviews: { ko: "내 최근 검토 요청", en: "My recent reviews" },
  dashboardViewAllReviews: { ko: "전체 보기", en: "View all" },
  dashboardNoRecentReviews: { ko: "아직 검토 요청이 없습니다.", en: "No reviews yet." },
  dashboardNoMyReviews: { ko: "첫 검토를 시작해 보세요.", en: "Start your first review." },
  dashboardReviewIssues: { ko: "지적 사항 보기", en: "Review issues" },
  dashboardViewDecision: { ko: "결정 보기", en: "View decision" },
  dashboardViewResult: { ko: "결과 보기", en: "View result" },
  dashboardViewProgress: { ko: "진행 상태 보기", en: "View progress" },
  navReviews: { ko: "광고 검토", en: "Reviews" },
  navPolicies: { ko: "정책 규정", en: "Policies" },
  navRules: { ko: "맞춤 규칙", en: "Custom Rules" },
  navSageWorkflow: { ko: "세이지 워크플로우", en: "Sage Workflow" },
  sageWorkflowTabEditor: { ko: "워크플로우", en: "Workflow" },
  sageWorkflowViewSwitcher: { ko: "적용 범위 보기", en: "Scope view" },
  sageWorkflowViewGraph: { ko: "컴플라이언스 그래프", en: "Compliance Graph" },
  sageWorkflowViewTable: { ko: "표", en: "Table" },
  sageWorkflowIntro: {
    ko: "게시 채널과 자료 카테고리가 정책, 맞춤 규칙, 금지 표현, 세이지 학습 규칙에 어떻게 연결되는지 확인하고 편집하세요. 컴플라이언스 그래프, 적용 범위 맵, 표 보기 중에서 골라 관계를 보거나 셀을 편집할 수 있습니다. 미게시 초안과 연결 없는 칸은 강조되며, ‘연결 없는 노드만’을 켜면 아직 연결되지 않은 조합만 표시됩니다. 검토는 채널과 카테고리가 모두 일치할 때만 해당 항목을 적용합니다. AI가 광고를 검토하는 동안에는 진행 패널에서 데이터 흐름을 볼 수 있습니다.",
    en: "View and edit how publishing channels and material categories connect to Policies, Custom Rules, Forbidden Expressions, and Educate Sage rules. Switch between the compliance graph, scope map, and table to see connections or inspect a cell. Unpublished drafts and unconnected cells are highlighted; turn on Unconnected only to show combinations that still need a connection. A review uses an item only when both dimensions match. While AI is reviewing a submission, watch the data flow in the progress panel.",
  },
  sageWorkflowUnmapped: { ko: "연결 없음", en: "Unmapped" },
  sageWorkflowUnconnectedOnly: { ko: "연결 없는 노드만", en: "Unconnected only" },
  sageWorkflowDraftCount: { ko: "초안 {count}", en: "{count} drafts" },
  scopeConnectInWorkflow: {
    ko: "세이지 워크플로우에서 채널과 자료 연결을 확인하세요.",
    en: "Review channel and category connections in Sage Workflow.",
  },
  scopeConnectInWorkflowAction: { ko: "워크플로우에서 연결", en: "Connect in Sage Workflow" },
  scopeItemWithVersion: { ko: "{title} v{version}", en: "{title} v{version}" },
  scopeDraftOpenAction: { ko: "연결 확인", en: "Review mapping" },
  sageWorkflowFullscreen: { ko: "전체 화면", en: "Fullscreen" },
  sageWorkflowExitFullscreen: { ko: "전체 화면 종료", en: "Exit fullscreen" },
  sageWorkflowActiveChannel: { ko: "편집 중인 채널", en: "Editing this channel" },
  sageWorkflowCanvasHint: {
    ko: "채널을 클릭해 편집할 채널을 선택하고, 카테고리를 클릭해 연결된 정책과 규칙을 확인하고 편집하세요. 드래그하여 이동, 스크롤로 확대하고 축소하세요.",
    en: "Click a channel to choose which one you're editing, and a category to view and edit its connected policies and rules. Drag to pan, scroll to zoom.",
  },
  sageGroupPolicies: { ko: "정책", en: "Policies" },
  sageGroupCustomRules: { ko: "맞춤 규칙", en: "Custom Rules" },
  sageGroupEducateSage: { ko: "세이지 학습", en: "Educate Sage" },
  sageGroupDictionary: { ko: "금지 표현 사전", en: "Forbidden Expressions" },
  sageGroupDictionaryHelp: {
    ko: "모든 자료 카테고리에 항상 적용됩니다.",
    en: "Always applies to every material category.",
  },
  sageGroupItemCount: { ko: "항목 {count}개", en: "{count} items" },
  sageWorkflowNoActiveReviews: {
    ko: "현재 AI가 검토 중인 자료가 없습니다.",
    en: "No materials are currently being reviewed by AI.",
  },
  sageLiveAiReview: { ko: "AI 검토", en: "AI Review" },
  sageLiveDecision: { ko: "결정", en: "Decision" },
  scopeMap: { ko: "적용 범위 맵", en: "Scope map" },
  scopeMaster: { ko: "적용 대상 설정", en: "Target settings" },
  scopeMapTitle: {
    ko: "채널과 자료 구분 연결 맵",
    en: "Channel and material relationship map",
  },
  scopeMapHelp: {
    ko: "채널을 선택한 뒤 자료 구분 노드를 열어 연결된 정책과 필수 심의 문구를 확인하거나 수정하세요.",
    en: "Choose a channel, then open a material node to review or edit its connected policies and required wording.",
  },
  scopeMapSearch: {
    ko: "자료 구분 또는 연결된 정책과 규칙 검색",
    en: "Search materials or connected policies and rules",
  },
  scopeChannels: { ko: "게시 채널", en: "Publishing channels" },
  scopeCombinations: { ko: "채널과 자료 조합", en: "Channel and material combinations" },
  scopeStepChannel: { ko: "게시 채널", en: "Publishing channel" },
  scopeStepMaterial: { ko: "자료 구분", en: "Material category" },
  scopeStepItems: { ko: "연결된 정책과 규칙", en: "Connected policies & rules" },
  scopeCombinationCount: { ko: "조합 {count}개", en: "{count} combinations" },
  scopeNoUnmapped: {
    ko: "이 채널의 모든 자료 구분에 정책 또는 규칙이 연결되어 있습니다.",
    en: "Every material category in this channel has a policy or rule connection.",
  },
  scopeNoMapResults: {
    ko: "검색 조건에 맞는 자료 구분이 없습니다.",
    en: "No material categories match this search.",
  },
  scopeInspector: { ko: "연결 항목", en: "Connected items" },
  scopeMatrixTitle: {
    ko: "구분 × 광고 유형 적용 매트릭스",
    en: "Material category × advertising channel matrix",
  },
  scopeMatrixHelp: {
    ko: "셀을 선택하여 해당 조합에 적용할 정책과 필수 심의 문구를 지정하세요. 변경 사항은 저장 및 활성화 후 AI 검토에 적용됩니다.",
    en: "Select a cell to assign policies and required review wording. Changes affect AI reviews only after saving and activation.",
  },
  scopeCellHelp: {
    ko: "이 조합으로 제출된 광고를 AI가 검토할 때 사용할 항목입니다.",
    en: "These items are used when AI reviews advertising submitted with this combination.",
  },
  scopeSearchItems: {
    ko: "정책 또는 심의 문구 검색",
    en: "Search policies or review wording",
  },
  scopeSelectAll: { ko: "전체 선택", en: "Select all" },
  scopeDeselectAll: { ko: "전체 해제", en: "Deselect all" },
  scopePolicyCount: { ko: "정책 {count}개", en: "{count} policies" },
  scopeRuleCount: { ko: "문구와 규칙 {count}개", en: "{count} rules" },
  scopeSaveActivate: {
    ko: "{count}개 항목 저장 및 활성화",
    en: "Save and activate {count} items",
  },
  scopeNeedsOneCell: {
    ko: "활성 정책과 규칙은 하나 이상의 조합에 연결되어야 합니다.",
    en: "An active policy or rule must remain connected to at least one combination.",
  },
  scopeSetupTitle: {
    ko: "컴플라이언스 적용 범위 설정을 완료하세요",
    en: "Finish setting up the compliance scope",
  },
  scopeSetupHelp: {
    ko: "고객사가 제공한 구분 구조를 한 번에 추가하면 바로 조합 매트릭스를 사용할 수 있습니다.",
    en: "Add the category structure supplied by the client in one step, then configure the matrix.",
  },
  scopeChannelsReady: {
    ko: "광고 유형 {count}개 준비됨",
    en: "{count} advertising channels ready",
  },
  scopeCategoriesMissing: {
    ko: "자료 구분 추가 필요",
    en: "Material categories need to be added",
  },
  scopeTemplatePreview: {
    ko: "상품(보장성, 연금, 저축, 통신판매전용, 방카슈랑스전용, 온라인전용), 업무, 이벤트(상품, 업무)",
    en: "Product (protection, annuity, savings, telemarketing, bancassurance, online), business, and event (product, business)",
  },
  scopeApplyTemplate: {
    ko: "고객사 자료 구분 템플릿 추가",
    en: "Add the client category template",
  },
  scopeChannelsMissing: {
    ko: "먼저 ‘적용 대상 설정’에서 광고 유형을 하나 이상 추가하세요.",
    en: "Add at least one advertising channel in Target settings first.",
  },
  scopeDraftMatrixWarning: {
    ko: "미게시 초안 {count}개가 작업 매트릭스에 표시됩니다. 현재 AI 검토에는 활성 버전이 계속 적용되며, 초안을 활성화한 뒤에 변경됩니다.",
    en: "{count} unpublished drafts are shown in this working matrix. AI reviews continue using the active versions until you activate these drafts.",
  },
  scopeDraftMappingHelp: {
    ko: "초안을 눌러 채널과 자료 카테고리를 지정하세요. 창에서 다른 미연결 초안을 고를 수 있습니다. 그래프, 맵, 표는 전체 연결을 검토할 때 사용하세요.",
    en: "Open a draft to choose its channels and material categories. You can switch to another unconnected draft in that window. Use the graph, map, and table to review overall connections.",
  },
  scopeDraftConnectTitle: { ko: "{title} v{version} 연결", en: "Connect {title} v{version}" },
  scopeDraftPicker: { ko: "미게시 초안", en: "Unpublished drafts" },
  scopeDraftUnconnected: { ko: "미연결", en: "Not connected" },
  scopeDraftConnected: { ko: "연결됨", en: "Connected" },
  scopeDraftSelectItem: { ko: "{title} v{version} 선택", en: "Select {title} v{version}" },
  scopeDraftConnectHelp: {
    ko: "이 초안을 적용할 게시 채널과 자료 카테고리를 선택하세요. 컴플라이언스 그래프, 적용 범위 맵, 표는 전체 연결을 검토하고 수정할 때 사용합니다.",
    en: "Choose the publishing channels and material categories this draft should cover. Use the compliance graph, scope map, and table to review or adjust overall connections.",
  },
  scopeDraftConnectAll: {
    ko: "모든 채널과 카테고리에 연결",
    en: "Connect to every channel and category",
  },
  scopeDraftConnectAllHelp: {
    ko: "앞으로 추가되는 채널과 카테고리에도 자동으로 적용됩니다.",
    en: "New channels and categories will be included automatically.",
  },
  scopeDraftConnectGroup: { ko: "{name} 전체 선택", en: "Select all in {name}" },
  scopeDraftCoverageCount: {
    ko: "{selected} / {total}개 조합 연결됨",
    en: "{selected} of {total} combinations connected",
  },
  scopeDraftSaveActivate: { ko: "저장 후 이 초안 활성화", en: "Save and activate this draft" },
  scopeActivateDraftsBusy: { ko: "초안 활성화 중…", en: "Activating drafts…" },
  scopeActivateDraftsPartial: {
    ko: "{succeeded}개는 활성화되었습니다. {failed}개는 실패했습니다: {titles}",
    en: "{succeeded} drafts were activated. {failed} could not be activated: {titles}",
  },
  scopeActivateDraftsFailed: {
    ko: "초안 {failed}개를 활성화하지 못했습니다: {titles}",
    en: "Could not activate {failed} drafts: {titles}",
  },
  scopeSaveActivatePartial: {
    ko: "{succeeded}개 항목을 저장하고 활성화했습니다. {failed}개는 실패했습니다: {titles}",
    en: "{succeeded} items were saved and activated. {failed} could not be completed: {titles}",
  },
  scopeSaveActivateFailed: {
    ko: "{failed}개 항목을 저장하고 활성화하지 못했습니다: {titles}",
    en: "Could not save and activate {failed} items: {titles}",
  },
  close: { ko: "닫기", en: "Close" },
  policies: { ko: "정책", en: "Policies" },
  rules: { ko: "규칙", en: "Rules" },
  policy: { ko: "정책", en: "Policy" },
  rule: { ko: "규칙", en: "Rule" },
  draft: { ko: "초안", en: "Draft" },
  scope: { ko: "적용 범위", en: "Scope" },
  sourceConfigurationChanged: {
    ko: "제출 후 컴플라이언스 적용 범위가 변경되었습니다.",
    en: "The compliance scope changed after this submission.",
  },
  sourceConfigurationChangedHelp: {
    ko: "현재 분석은 제출 시 고정된 정책과 규칙을 유지합니다. 최신 설정으로 다시 검토하려면 새 리비전을 생성하세요.",
    en: "This analysis keeps the policies and rules locked at submission. Create a new revision to review it with the latest configuration.",
  },
  rerunLatest: { ko: "최신 설정으로 다시 검토", en: "Re-run with latest configuration" },
  rerunReviewShort: { ko: "다시 검토", en: "Re-run review" },
  analysisStarting: { ko: "분석을 시작하는 중…", en: "Starting the analysis…" },
  rerunLatestConfirm: {
    ko: "동일한 자료로 새 리비전을 만들고 최신 정책과 규칙을 적용하시겠습니까?",
    en: "Create a new revision of the same material using the latest policies and rules?",
  },
  navConfig: { ko: "검토 설정", en: "Review Settings" },
  navMembers: { ko: "구성원", en: "Members" },
  navAudit: { ko: "감사 기록", en: "Audit" },
  navProfile: { ko: "내 프로필", en: "My Profile" },
  navOrganizations: { ko: "조직 관리", en: "Organizations" },
  sidebarNavigation: { ko: "사이드바 탐색", en: "Sidebar navigation" },
  topNavigation: { ko: "상단 메뉴", en: "Main menu" },
  collapseSidebar: { ko: "사이드바 접기", en: "Collapse sidebar" },
  expandSidebar: { ko: "사이드바 펼치기", en: "Expand sidebar" },
  resizeSidebar: { ko: "사이드바 너비 조절", en: "Resize sidebar" },
  navSuperAdmin: { ko: "슈퍼 관리자", en: "Super Admin" },
  refresh: { ko: "새로고침", en: "Refresh" },
  superAdminIntro: {
    ko: "슈퍼 관리자만 사용할 수 있는 플랫폼 관리 기능입니다.",
    en: "Platform management tools available only to Super Admins.",
  },
  activeOrganization: { ko: "현재 조직", en: "Active organization" },
  selectOrganization: { ko: "조직 선택", en: "Select organization" },
  visitOrganization: { ko: "조직 열기", en: "Open organization" },
  switchOrganization: { ko: "조직 전환", en: "Switch organization" },
  switchOrganizationFailed: {
    ko: "조직을 전환하지 못했습니다. 다시 시도해 주세요.",
    en: "Could not switch organization. Please try again.",
  },
  selected: { ko: "선택됨", en: "Selected" },
  currentOrganization: { ko: "현재 조직", en: "Current" },
  organizationRequired: { ko: "조직을 선택해 주세요", en: "Select an organization" },
  organizationRequiredHelp: {
    ko: "조직 기능을 사용하려면 슈퍼 관리자 > 조직 관리에서 조직을 새 탭으로 열어 주세요.",
    en: "Open an organization in a new tab from Super Admin → Organizations to use tenant features.",
  },
  organizationsIntro: {
    ko: "플랫폼의 조직을 만들고, 작업할 조직을 새 탭으로 엽니다.",
    en: "Create platform organizations and open the tenant you want to work in as a new tab.",
  },
  navVaultsageOrphans: { ko: "VaultSage 정리", en: "VaultSage cleanup" },
  navLlmSettings: { ko: "LLM 설정", en: "LLM settings" },
  vaultsageOrphansIntro: {
    ko: "삭제된 조직이 VaultSage에 남긴 폴더를 확인하고 정리합니다.",
    en: "Find and remove VaultSage folders left behind after an organization was deleted.",
  },
  vaultsageOrphansEmpty: { ko: "정리할 폴더가 없습니다.", en: "There are no leftover folders to clean up." },
  vaultsageOrphansNoScanner: {
    ko: "환경 홈을 볼 수 있는 활성 조직의 VaultSage API 키가 없습니다. 먼저 조직 관리에서 유효한 팀 API 키를 설정하세요.",
    en: "No live organization has a VaultSage API key that can see the environment home. Configure a working Team API key on a live organization first.",
  },
  vaultsageOrphanDeletedOrg: { ko: "삭제된 조직", en: "Deleted organization" },
  vaultsageOrphanNoOrg: { ko: "일치하는 조직 없음", en: "No matching organization" },
  vaultsageOrphanArchivedAt: { ko: "삭제일", en: "Deleted" },
  vaultsageOrphanCleanup: { ko: "정리", en: "Clean up" },
  vaultsageOrphanCleanupConfirm: {
    ko: '"{folder}" 폴더를 삭제할까요? {org}의 VaultSage 문서가 영구 삭제됩니다.',
    en: 'Delete the "{folder}" folder? VaultSage documents for {org} will be permanently removed.',
  },
  vaultsageOrphanCleanupConfirmUnmatched: {
    ko: '"{folder}" 폴더를 삭제할까요? 이 폴더와 안의 파일이 영구 삭제됩니다.',
    en: 'Delete the "{folder}" folder? This folder and its files will be permanently removed.',
  },
  vaultsageOrphansInaccessible: { ko: "접근할 수 없는 삭제된 조직", en: "Inaccessible deleted organizations" },
  vaultsageOrphansInaccessibleHelp: {
    ko: "이 조직의 폴더는 현재 활성 조직의 API 키로 보이지 않습니다. 해당 공간에 접근할 수 있는 키를 설정한 뒤 다시 시도하세요.",
    en: "These organizations have pinned folders that no live API key can see. Configure a key that can reach that space, then try again.",
  },
  errCleanupVaultsageOrphan: {
    ko: "폴더를 정리하지 못했습니다.",
    en: "Could not clean up this folder.",
  },
  navAdminUsers: { ko: "전체 사용자 계정", en: "All User Accounts" },
  adminUsersIntro: {
    ko: "플랫폼의 모든 사용자 계정을 조회하고, 조직에 배정하며, 슈퍼 관리자 권한을 관리합니다.",
    en: "View every account on the platform, assign users to organizations, and manage Super Admin access.",
  },
  createOrganization: { ko: "새 조직 만들기", en: "Create organization" },
  organizationName: { ko: "조직 이름", en: "Organization name" },
  organizationNamePlaceholder: { ko: "예: 누리 보험", en: "For example, Acme Insurance" },
  initialAdminEmail: { ko: "초기 관리자 이메일 (선택)", en: "Initial Admin email (optional)" },
  initialAdminEmailHelp: {
    ko: "입력하면 해당 이메일에 조직 관리자 역할의 대기 중 초대가 생성됩니다.",
    en: "When provided, a pending organization Admin invitation is created for this email.",
  },
  vaultsageCredentialType: { ko: "VaultSage 자격 증명 유형", en: "VaultSage credential type" },
  vaultsageApiKey: { ko: "VaultSage API 키", en: "VaultSage API key" },
  showApiKey: { ko: "API 키 보기", en: "Show API key" },
  hideApiKey: { ko: "API 키 숨기기", en: "Hide API key" },
  vaultsageTeamApiKey: { ko: "팀 API 키", en: "Team API key" },
  vaultsageCredentialFingerprint: { ko: "지문", en: "fingerprint" },
  vaultsagePersonalApiKey: { ko: "개인 API 키", en: "Personal API key" },
  vaultsageCredentialCreationHelp: {
    ko: "API 키는 조직을 만들기 전에 암호화되어 검증됩니다.",
    en: "The API key is encrypted and validated before the organization is created.",
  },

  // Credential kind choice: which VaultSage space the organization's files land in
  vaultsageTeamApiKeyRecommended: { ko: "팀 API 키 (권장)", en: "Team API key (recommended)" },
  vaultsageTeamApiKeyDescription: {
    ko: "파일을 팀 공유 공간에 저장합니다. 담당자가 바뀌어도 조직 문서가 유지되며, 접근 권한은 팀 구성원 관리로 처리됩니다.",
    en: "Files are stored in the team's shared space. The organization survives staff changes, and access is managed by team membership.",
  },
  vaultsagePersonalApiKeyDemoOnly: { ko: "개인 API 키 (데모, 개인용)", en: "Personal API key (demo and personal use only)" },
  vaultsagePersonalApiKeyDescription: {
    ko: "데모와 개인용으로만 사용하세요. 파일이 키 소유자의 개인 공간에 저장되며, 나중에 다른 계정으로 옮길 수 없습니다. 해당 담당자가 퇴사하면 조직 문서에 접근할 수 없게 되어 조직을 다시 만들어야 합니다.",
    en: "For demo and personal use only. Files are stored in the key owner's personal space and cannot be transferred to another account later. If that person leaves, the organization's documents become unreachable and the organization must be recreated.",
  },
  vaultsagePersonalApiKeyAcknowledge: {
    ko: "이 조직의 파일을 다른 계정으로 옮길 수 없다는 점을 이해했습니다.",
    en: "I understand this organization's files cannot be transferred to another account.",
  },
  vaultsagePersonalSpaceBadge: { ko: "개인 공간", en: "Personal drive" },

  // Where the files actually are, versus where the credential kind says they should be
  vaultsageStorageLocation: { ko: "저장 위치", en: "Storage" },
  vaultsageSpaceTeam: { ko: "팀 공간", en: "Team space" },
  vaultsageSpacePersonal: { ko: "개인 공간", en: "Personal drive" },
  vaultsageSpaceUnknown: { ko: "확인되지 않음", en: "Not verified" },
  vaultsageSpaceMissing: { ko: "존재하지 않음", en: "No longer exists" },
  vaultsageStorageMissing: {
    ko: "이 조직에 기록된 VaultSage 폴더가 더 이상 존재하지 않습니다. API 키는 정상입니다. 다음 업로드 시 폴더를 새로 만들지만, 이전에 올린 파일은 복구되지 않으므로 다시 업로드해야 합니다.",
    en: "The VaultSage folders recorded for this organization no longer exist. The API key still works. The next upload will create them again, but previously uploaded files are not recoverable and must be re-uploaded.",
  },
  vaultsageStorageVerifiedAt: { ko: "확인 시점", en: "Last verified" },
  vaultsageStorageNeverVerified: { ko: "확인한 적 없음", en: "Never verified" },
  vaultsageVerifyNow: { ko: "지금 확인", en: "Verify now" },
  vaultsageVerifying: { ko: "확인 중...", en: "Verifying..." },
  vaultsageStorageVerified: {
    ko: "저장 위치를 확인했습니다: {path}",
    en: "Storage verified: {path}",
  },
  vaultsageStorageVerifyFailed: {
    ko: "저장 위치를 확인하지 못했습니다. API 키가 더 이상 유효하지 않을 수 있습니다.",
    en: "Could not verify storage. The API key may no longer be valid.",
  },
  vaultsageStorageMismatch: {
    ko: "이 조직은 {expected}를 쓰는 키로 설정되어 있지만, 파일은 {actual}({owner})에 저장되어 있습니다. 새 업로드도 계속 그곳으로 갑니다. 옮기려면 파일 마이그레이션이 필요합니다.",
    en: "This organization is configured with a key for the {expected}, but its files are stored in the {actual} ({owner}). New uploads continue to go there. Moving them requires file migration.",
  },
  vaultsageStorageLegacyLayout: {
    ko: "조직별 폴더가 없는 이전 구조입니다. 그대로 동작하지만, 같은 공간을 다른 조직과 공유할 수 없습니다.",
    en: "This storage uses the older layout without a per-organization folder. It keeps working, but the space cannot be shared with another organization.",
  },

  replaceVaultsageCredential: { ko: "VaultSage API 키 교체", en: "Rotate VaultSage API key" },
  newVaultsageApiKey: { ko: "새 VaultSage API 키", en: "New VaultSage API key" },
  vaultsageCredentialReplacementHelp: {
    ko: "같은 VaultSage 계정의 새 키를 입력하세요. 파일이 이미 있는 조직에서는 다른 계정의 키나 다른 유형의 키를 쓸 수 없으며, 그 경우 파일 마이그레이션이 필요합니다.",
    en: "Enter a new key for the same VaultSage account. Once files exist, a key belonging to a different account — or a different key type — cannot be accepted; that requires file migration instead.",
  },
  vaultsageCredentialKindLocked: {
    ko: "파일이 이미 저장되어 있어 키 유형은 바꿀 수 없습니다. 현재 유형: {kind}",
    en: "The key type cannot be changed because files are already stored. Current type: {kind}",
  },
  vaultsageCredentialUpdateFailed: {
    ko: "VaultSage 자격 증명을 업데이트하지 못했습니다.",
    en: "Failed to update VaultSage credential.",
  },
  vaultsageCredentialStatus: { ko: "VaultSage", en: "VaultSage" },
  vaultsageCredentialNotConfigured: { ko: "설정되지 않음", en: "Not configured" },
  apiKey: { ko: "API 키", en: "API key" },
  vaultsageRootPathNotProvisioned: { ko: "아직 생성되지 않음", en: "Not provisioned yet" },
  vaultsageKey: { ko: "VaultSage 키", en: "VaultSage key" },
  baselineGuide: { ko: "기준 가이드", en: "Baseline guide" },
  applyBaselineGuide: { ko: "기준 가이드 적용", en: "Apply baseline guide" },
  applyBaselineGuideHelp: {
    ko: "매체, 구분1/구분2, 필수안내사항, 금지 표현 사전의 기준 내용을 이 조직에 적용합니다. 이미 승인된 가이드 항목과 기존 사전 항목은 그대로 유지됩니다.",
    en: "Loads the baseline channels, category taxonomy, guide items, and forbidden expression dictionary into this organization. Approved guide items and existing dictionary entries are left untouched.",
  },
  confirmApplyBaselineGuide: {
    ko: "{name} 조직에 기준 가이드를 적용하시겠습니까?",
    en: "Apply the baseline guide to {name}?",
  },
  baselineGuideAlreadyApplied: {
    ko: "이미 적용되어 있어 새로 만든 항목이 없습니다. 기존 가이드 항목 {skipped}개는 그대로 두었습니다.",
    en: "Already applied: nothing new was created and {skipped} existing entries were left unchanged.",
  },
  baselineGuideInProgress: {
    ko: "이 조직에 기준 가이드를 적용하는 작업이 이미 진행 중입니다. 완료된 뒤 다시 시도하세요.",
    en: "The baseline guide is already being applied to this organization. Try again once it finishes.",
  },
  baselineGuideApplied: {
    ko: "기준 가이드를 적용했습니다. 매체 {channels}개, 구분 {categories}개, 가이드 항목 {guideItems}개, 금지 표현 {dictionary}개를 새로 만들고 {skipped}개는 그대로 두었습니다.",
    en: "Baseline guide applied: {channels} channels, {categories} categories, {guideItems} guide items, and {dictionary} dictionary entries created; {skipped} left unchanged.",
  },
  errApplyBaselineGuide: {
    ko: "기준 가이드를 적용하지 못했습니다.",
    en: "Failed to apply the baseline guide.",
  },
  create: { ko: "만들기", en: "Create" },
  creating: { ko: "만드는 중...", en: "Creating..." },
  noOrganizations: { ko: "등록된 조직이 없습니다.", en: "No organizations are available." },
} as const satisfies Record<string, Entry>;
